import BaseObject from '../../../../base/base_object';
import Device from '../../../../utils/device/device';
import _ from "../../../../utils/underscore";
import {KEY_NAME} from "../../native/native_const";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../events/events";


class GameLauncher extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GameLauncher';

    _HybridService = null;
    _bEnableLocalGameLauncher = false;
    _bEnable = false;


    init(params) {

        if (Device.hybrid.isEmbedded) {
            params = params.ios;
            if (!_.isNullOrUndefined(params) && !_.isNullOrUndefined(params.enable)) {
                this._bEnable = params.enable;
            }
        }

        super.init(params);
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;

        if (this._bEnable) {
            Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, this.checkLocalGameLauncher, this);
        }

        return this;
    }

    checkLocalGameLauncher(){

        this._HybridService.checkLocalGameLauncher().then(data => {
            data = _.safeJSONandDecode(data);

            let error = data[KEY_NAME.ERROR];
            if (error !== 0) {
                return;
            }

            let keyData = data[KEY_NAME.DATA];
            if(undefined !== keyData) {
                const isSupported = (keyData[KEY_NAME.LOCAL_GAME_LAUNCHER_SUPPORTED] === 'true');

                if(isSupported) {
                    this._HybridService.loadGameLauncher();
                    this._HybridService.loadGamePreLoader();
                    this.setLocalGameLauncherSupported(isSupported);
                }
            }
        })
    }

    setLocalGameLauncherSupported(val){
        this._bEnableLocalGameLauncher = val;
    }

    isLocalGameLauncherSupported(){
        return this._bEnableLocalGameLauncher;
    }

}
export default GameLauncher;
